import { DATASET } from './dataset'

export const DATASET_OPTIONS = [
  { value: DATASET.PHARMACY, label: '薬局事業所' },
  { value: DATASET.SERVICE, label: '薬局サービス' },
  { value: DATASET.OPENING_HOURS, label: '開局時間' },
]
